import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: [],
    courseId: '',
    unit: {},
    module: {},
    pdf: {},
    image: {},
    text: {},
    video: {}
};

const currentCourse = createSlice({
    name: 'currentCourse',
    initialState,
    reducers: {
        getCurrentCourse: (state, { payload }) => {
            console.log('payload', payload);
            if (!payload || (Array.isArray(payload) && payload.length === 0)) {
                state.data = [];
                state.courseId = '';
                state.unit = {};
                state.module = {};
                state.pdf = {};
                state.image = {};
                state.text = {};
                state.video = {};
            } else {
                state.data = payload;
                state.courseId = payload?._id;
            }
        },
        getCurrentUnit: (state, { payload }) => {
            console.log('unit payload', payload);
            state.unit = payload;
            if (
                state.data &&
                state.data.units &&
                Array.isArray(state.data.units)
            ) {
                const idx = state.data.units.findIndex(
                    (u) => u._id === payload?._id
                );
                if (idx !== -1) {
                    state.data.units[idx] = {
                        ...state.data.units[idx],
                        ...payload
                    };
                }
            }
        },
        getCurrentModule: (state, { payload }) => {
            console.log('module payload', payload);
            state.module = payload;
            if (
                state.unit &&
                state.unit.modules &&
                Array.isArray(state.unit.modules)
            ) {
                const mIdx = state.unit.modules.findIndex(
                    (m) => m._id === payload?._id
                );
                if (mIdx !== -1) {
                    state.unit.modules[mIdx] = {
                        ...state.unit.modules[mIdx],
                        ...payload
                    };
                }
            }
            if (
                state.data &&
                state.data.units &&
                Array.isArray(state.data.units)
            ) {
                const uIdx = state.data.units.findIndex(
                    (u) => u._id === state.unit?._id
                );
                if (uIdx !== -1 && Array.isArray(state.unit?.modules)) {
                    state.data.units[uIdx] = {
                        ...state.data.units[uIdx],
                        modules: [...state.unit.modules]
                    };
                }
            }
        },
        getCurrentModulePdf: (state, { payload }) => {
            console.log('module payload', payload);
            state.pdf = payload;
        },
        getCurrentModuleVideo: (state, { payload }) => {
            console.log('module payload', payload);
            state.video = payload;
        },
        getCurrentModuleImage: (state, { payload }) => {
            console.log('module payload', payload);
            state.image = payload;
        },
        getCurrentModuleText: (state, { payload }) => {
            console.log('module payload', payload);
            state.text = payload;
        }
    }
});

export const {
    getCurrentCourse,
    getCurrentUnit,
    getCurrentModule,
    getCurrentModuleImage,
    getCurrentModulePdf,
    getCurrentModuleVideo,
    getCurrentModuleText
} = currentCourse.actions;
export default currentCourse.reducer;
